module.exports = __webpack_public_path__ + "img/video-series-white.44a425bd.svg";